<template>
    <v-row no-gutters class="mb-2">
        <v-col class="pe-2">
            <PDatePicker
                label="Due Date"
                outlined
                hide
                :rules="[isRequired]"
                v-model="line.date"/>
        </v-col>
        <v-col class="pe-2">
            <v-text-field
                label="Number"
                outlined
                :rules="[isRequired]"
                dense
                v-model="line.number"
                hide-details="auto">
            </v-text-field>
        </v-col>
        <v-col class="pe-2">
            <v-autocomplete
                label="Bank"
                outlined
                :items="bankAccounts"
                item-text="name"
                :rules="[isRequired]"
                item-value="id"
                v-model="line.ledger_account_id"
                dense
                hide-details="auto">
            </v-autocomplete>
        </v-col>
        <v-col class="pe-2 d-flex align-center">
            <v-text-field
                label="Amount"
                outlined
                dense
                :rules="[isRequired, isNumeric]"
                v-model="line.amount"
                :prefix="currency ? currency.abbreviation : null"
                hide-details="auto">
            </v-text-field>
            <v-btn icon @click="$emit('cheque:delete', index)">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>

import PDatePicker from '@/components/common/PDatePicker';
import { isRequired, isNumeric } from './../../utils/validations';

export default {
    name: "PurchasePaymentFormCheque",
    components: {
        PDatePicker
    },
    props: {
        value: Object,
        index: Number,
        bankAccounts: Array,
        currency: Object,
        exchangeRate: Object
    },
    computed: {
        baseAmount() {
            if(!this.exchangeRate) return 0;
            return this.line.amount * this.exchangeRate.rate;
        }
    },
    watch: {
        line: {
            deep: true,
            handler(value) {
                this.$emit("input", {...value, base_amount: this.baseAmount})
            }
        },
        exchangeRate: {
            deep: true,
            handler(value) {
                this.$emit("input", {...value, base_amount: this.baseAmount})
            }
        }
    },
    data() {
        return {
            line: {}
        }
    },
    methods: {
        isNumeric, isRequired,
    },
    created() {
        this.line = {...this.value};
    }
}
</script>

<style>

</style>